// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"460":"f4334e4c","603":"ef102dd9","720":"2038fb6c"}[chunkId] + ".chunk.css";
};